import { newE2EPage } from "@stencil/core/testing";

describe("toast-message", () => {
    it("should render a component and match snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-toast-message message="Test Message">Test Slot</ux-toast-message>`);
        const el = await page.find("ux-toast-message");
        expect(el).toHaveClass("hydrated");
        await page.waitForTimeout(250);
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should remove itself from the DOM tree when its lifetime expires", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-toast-message message="Test Message" lifetime="500"></ux-toast-message>`);
        const uxRemove = await page.spyOnEvent("uxRemove");
        const el = await page.find("ux-toast-message");
        expect(el).toHaveAttribute("transition-phase");
        await page.waitForTimeout(1000);
        expect(uxRemove).toHaveReceivedEvent();
        const el2 = await page.find("ux-toast-message");
        expect(el2).toBeNull();
    });

    it("should remove the message when the close button is clicked", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-toast-message message="Test Message"></ux-toast-message>`);
        const uxRemove = await page.spyOnEvent("uxRemove");
        const el = await page.find("ux-toast-message");
        await page.waitForTimeout(200);
        await page.waitForChanges();
        expect(el.getAttribute("transition-phase")).toBe("idle");
        const closeBtn = await page.find("ux-toast-message >>> .ux-toast-message__remove");
        await closeBtn.click();
        expect(uxRemove).toHaveReceivedEvent();
        await page.waitForTimeout(200);
        const el2 = await page.find("ux-toast-message");
        expect(el2).toBeNull();
    });

    it("should remove the message when the close method is called", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-toast-message message="Test Message"></ux-toast-message>`);
        const uxRemove = await page.spyOnEvent("uxRemove");
        const el = await page.find("ux-toast-message");
        await page.waitForTimeout(200);
        await page.waitForChanges();
        expect(el.getAttribute("transition-phase")).toBe("idle");
        await el.callMethod("close");
        expect(uxRemove).toHaveReceivedEvent();
        await page.waitForTimeout(200);
        await page.waitForChanges();
        const el2 = await page.find("ux-toast-message");
        expect(el2).toBeNull();
    });
});
